import { post } from '../utility';

export const search = ({ month, year, callback }) => {
	post({
		method: 'dataRecord.manualInput.search',
		params: { month, year },
		callback,
	});
};

export const update = ({ dataRecordId, fieldValue, callback }) => {
	post({
		method: 'dataRecord.manualInput.update',
		params: { dataRecordId, fieldValue },
		callback,
	});
};

export const add = ({ fieldName, dayKey, fieldValue, callback }) => {
	post({
		method: 'dataRecord.manualInput.add',
		params: { fieldName, dayKey, fieldValue },
		callback,
	});
};
